var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"loading"},[_c('vue-loading',{attrs:{"type":"spin","color":"#f7f7f7","size":{ width: '100px', height: '100px'}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }